export class LogModel {
	methodName!: string;
	parameters!: string;
	deviceIdentifier!: string;
	timeStamp!: Date;
	isError!: boolean;
}